import React from "react";
import cozy_logo from './cozy_dikastiria_logo.png';

const Logo = () => {
  return (
  <img className="logo" /* always in the center and move from styles.css*/
  src={cozy_logo}>
  </img>
  );
};

export default Logo;
